export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/building_complex.c1c8b9e.svg";